"use client";

import cx from "classnames";

import styles from "../../../index.module.scss";
import { useWizard } from "../../context";

export default function StepCrumbs() {
  const { state } = useWizard();

  const { currentStep, steps } = state;

  return (
    <div className={cx(styles["steps-wrapper"], "d-none d-lg-flex justify-content-center")}>
      {steps.map((step, index) => (
        <div
          key={index}
          className={cx(styles.step, "d-flex align-items-center me-3", {
            [styles.dirty]: currentStep.id >= step.id,
          })}
        >
          <div className={cx(styles["number"], "d-flex justify-content-center align-items-center")}>
            {index + 1}
          </div>
          <span className="mx-2">{step.title}</span>
          {steps.length !== index + 1 && (
            <div
              className={cx(styles.divider, {
                [styles.completed]: currentStep.id > step.id,
              })}
            >
              <div />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
